import { useState } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";

export enum WalletOptions {
  Cards = "cards",
  Credits = "credits",
}

interface UseWalletDisplayReturn {
  context: {
    selectedOption: WalletOptions;
    options: Array<{ label: string; value: WalletOptions }>;
  };
  handlers: { onOptionChange: (value: string) => void };
}

export const useWalletDisplay = (): UseWalletDisplayReturn => {
  const { t } = useI18nContext();
  const [selectedOption, setSelectedOption] = useState<WalletOptions>(
    WalletOptions.Cards
  );

  const options = [
    {
      label: t("wallet.cards.title"),
      value: WalletOptions.Cards,
    },
    {
      label: t("wallet.credits.title"),
      value: WalletOptions.Credits,
    },
  ];

  const onOptionChange = (value) => {
    setSelectedOption(value);
  };

  return {
    context: {
      selectedOption,
      options,
    },
    handlers: { onOptionChange },
  };
};
